
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "28",
    "height": "40"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#FFF",
        "fill-rule": "evenodd",
        "d": "M25.94 21.705L15.32 39.437c-.205.342-.574.553-.972.556h-.01c-.395 0-.763-.204-.972-.541L2.469 21.891C1.128 19.726.42 17.229.42 14.672.42 7.103 6.578.944 14.148.944c7.57 0 13.728 6.159 13.728 13.728 0 2.482-.67 4.914-1.936 7.033zM14.148 3.217c-6.308 0-11.456 5.147-11.456 11.455 0 2.132.606 4.211 1.722 6.014l9.907 15.965 9.655-16.12c1.055-1.764 1.62-3.791 1.62-5.859 0-6.308-5.14-11.455-11.448-11.455zm0 18.319c-3.835 0-6.864-3.103-6.864-6.864 0-3.785 3.079-6.864 6.864-6.864 3.785 0 6.864 3.079 6.864 6.864 0 3.72-2.982 6.864-6.864 6.864zm0-11.455c-2.523 0-4.591 2.068-4.591 4.591 0 2.53 2.054 4.591 4.591 4.591 2.576 0 4.584-2.098 4.584-4.591 0-2.523-2.061-4.591-4.584-4.591z"
      }
    }
  ]
})
    }
  